import styled from 'styled-components';
import { media } from '../../helpers';

export const Space = styled.div`
  padding: 0;
  ${media.sm(`
    padding: 0 10px;
  `)}
`;
